<template>
  <div class="do-now">
    <p class="do-now__label">Do this now</p>
    <h1 class="do-now__text"><Amounts :text="parts.first"/></h1>
    <p v-for="(line, i) in parts.rest" :key="i" class="do-now__more"><Amounts :text="line"/></p>
    <!-- What this screen uses, with amounts, inside the banner so it reads
         as part of the thing to do now (household feedback, 2026-10-12). -->
    <p v-if="needs?.length" class="do-now__needs"><span class="do-now__needs-label">You’ll need</span><template v-for="(item, i) in needs" :key="i"><span v-if="i" class="do-now__sep">&nbsp;· </span><Amounts :text="item"/></template></p>
  </div>
</template>

<script>
// The instruction on a cook-mode screen, framed as the thing to do NOW
// (household feedback, 2026-10-12: a plain heading like "Nestle the thighs
// skin-side up..." read like a description or a preview, not the step to
// perform). The label and the panel do the work; the recipe words are
// unchanged, split by headline() into a bold first sentence and the rest.
// `needs` (what the screen uses, with amounts) sits in the same panel.
import { computed } from 'vue';
import Amounts from './Amounts.vue';
import { headline } from '../utils/readable.js';

export default {
  name: 'DoNow',
  components: { Amounts },
  props: { text: { type: String, default: '' }, needs: { type: Array, default: () => [] } },
  setup (props) {
    return { parts: computed(() => headline(props.text)) };
  }
};
</script>

<style scoped>
.do-now { background: var(--accent-soft); border-left: 6px solid var(--accent); border-radius: var(--radius); padding: 0.75rem 1rem 0.85rem; }
.do-now__label { font-size: 0.78rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); margin: 0 0 0.3rem; }
.do-now__text { font-size: 1.7rem; font-weight: 800; line-height: 1.3; margin: 0; }
.do-now__more { font-size: 1.2rem; line-height: 1.4; margin: 0.4rem 0 0; }
.do-now__needs { font-size: 1.15rem; line-height: 1.45; margin: 0.65rem 0 0; padding-top: 0.55rem; border-top: 1px solid var(--line); }
.do-now__needs-label { display: block; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--muted); margin: 0 0 0.15rem; }
.do-now__sep { color: var(--muted); }
@media (min-width: 700px) { .do-now__text { font-size: 2.1rem; } }
</style>
